<template>
    <header :class="headerClass">
        <h1 :class="headingClass">
            <div v-if="$slots.heading">
                <slot name="heading"></slot>
            </div>

            <span>{{ heading }}</span>

            <div v-if="$slots.right" class="page-header__right">
                <slot name="right"></slot>
            </div>
        </h1>

        <div v-if="content || $slots.content" :class="contentClass">
            <span v-html="content"></span>
            <slot name="content"></slot>
        </div>
    </header>
</template>

<script>
    export default {
        props: {
            heading: { type: String, default: '' },
            content: { type: String, default: '' },
            isCenter: { type: Boolean, default: false },
            size: { type: String, default: undefined },
            contentSpacing: { type: String, default: undefined },
            contentColor: { type: String, default: 'primary' },
        },

        computed: {
            headerClass() {
                return {
                    'page-header': true,
                    'page-header--is-center': this.isCenter,
                    [`page-header--size-${this.size}`]: this.size,
                    [`page-header--spacing-${this.contentSpacing}`]: this.contentSpacing,
                }
            },
            headingClass() {
                return {
                    'page-header__heading': true,
                    [`page-header--spacing-${this.contentSpacing}`]: this.contentSpacing,
                }
            },
            contentClass() {
                return {
                    'page-header__content': true,
                    'page-header--is-start': this.isCenter,
                    [`page-header__content--color-${this.contentColor}`]: true,
                }
            },
        },
    }
</script>
